import React from 'react';
import { Link } from 'react-router-dom';
import { User, Trophy, TrendingUp, ChevronRight } from 'lucide-react';

const TopTraders = ({ traders = [], loading = false }) => {
  if (loading) {
    return (
      <div className="bg-[#121826] rounded-2xl border border-[#1E293B] overflow-hidden" data-testid="top-traders-widget">
        <div className="bg-[#1E293B] px-4 py-3">
          <div className="h-5 bg-[#0A0E17] rounded w-24 animate-pulse" />
        </div>
        <div className="p-4 space-y-3">
          {[1,2,3,4,5].map(i => (
            <div key={i} className="flex items-center gap-3 animate-pulse">
              <div className="w-6 h-6 bg-[#1E293B] rounded-full" />
              <div className="w-8 h-8 bg-[#1E293B] rounded-full" />
              <div className="flex-1"><div className="h-4 bg-[#1E293B] rounded w-20 mb-1" /><div className="h-3 bg-[#1E293B] rounded w-16" /></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bg-[#121826] rounded-2xl border border-[#1E293B] overflow-hidden" data-testid="top-traders-widget">
      <div className="bg-[#1E293B] px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Trophy className="w-5 h-5 text-[#F59E0B]" />
          <h3 className="text-[#F8FAFC] font-bold font-heading">Top Traders</h3>
        </div>
        <Link to="/leaderboards" className="text-[#F59E0B] text-sm hover:underline flex items-center gap-1">
          More <ChevronRight className="w-4 h-4" />
        </Link>
      </div>

      <div className="divide-y divide-[#1E293B]">
        {traders.length > 0 ? traders.slice(0, 9).map((trader, index) => (
          <Link key={trader.user_id || index} to={`/profile/${trader.username}`}
            className="flex items-center gap-3 px-4 py-3 hover:bg-[#1E293B]/50 transition-colors"
            data-testid={`top-trader-row-${index}`}
          >
            <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold font-mono ${
              index === 0 ? 'bg-[#F59E0B] text-black' : index === 1 ? 'bg-[#94A3B8] text-black' : index === 2 ? 'bg-[#B45309] text-white' : 'bg-[#1E293B] text-[#64748B]'
            }`}>{index + 1}</div>
            <div className="w-8 h-8 rounded-full bg-[#1E293B] flex items-center justify-center overflow-hidden">
              {trader.avatar ? <img src={trader.avatar} alt={trader.username} className="w-full h-full object-cover" /> : <User className="w-4 h-4 text-[#64748B]" />}
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[#F8FAFC] text-sm font-medium truncate">{trader.username}</div>
              <div className="text-[#64748B] text-xs font-mono">B₹{((trader.net_worth || 0) / 100000).toFixed(1)}L</div>
            </div>
            <div className={`flex items-center gap-1 text-sm font-mono font-medium ${(trader.change_percent || 0) >= 0 ? 'text-[#10B981]' : 'text-[#EF4444]'}`}>
              <TrendingUp className="w-3 h-3" />
              {(trader.change_percent || 0) >= 0 ? '+' : ''}{(trader.change_percent || 0).toFixed(1)}%
            </div>
          </Link>
        )) : (
          <div className="px-4 py-8 text-center text-[#64748B]">No traders yet. Be the first!</div>
        )}
      </div>
    </div>
  );
};

export default TopTraders;
